const DefaultAspectRatio = '1:1';

const SkuTypes = [
  {
    name: 'FRAMED_PHOTO',
    label: 'Square 20X20cm',
    description: 'Stickable Frame 20X20 Cm',
    aspectRatio: '1:1',
  },
  {
    name: 'FRAMED_RECT_20X30',
    label: 'Portrait 20X30cm',
    description: 'Stickable Portrait Rectangle Frame 20X30 Cm',
    aspectRatio: '2:3',
  },
  {
    name: 'FRAMED_RECT_30X20',
    label: 'Landscape 30X20cm',
    description: 'Stickable Landscape Rectangle Frame 30X20 Cm',
    aspectRatio: '3:2',
  },
  {
    name: 'FRAMED_SQUARE_30X30',
    label: 'Square 30X30cm',
    description: 'Stickable Square Frame 30X30 Cm',
    aspectRatio: '1.5:1.5',
  },
];

const ArtSkuTypes = [
  {
    name: 'ART_FRAMED_RECT_20X30',
    title: '20X30 cm',
    aspectRatio: '20:30',
    orientation: 'vertical',
    getFrameSettings: () => {
      return { width: 221, height: 331.5 };
    },
    convertTransformOptionsFromBaseToReal: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX,
        translateY,
      };
    },
    convertTransformOptionsFromRealToBase: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX,
        translateY,
      };
    },
  },
  {
    name: 'ART_FRAMED_RECT_30X42',
    title: '30X42 cm',
    aspectRatio: '30:42',
    orientation: 'vertical',
    getFrameSettings: () => {
      return { width: 331.5, height: 464.1 };
    },
    convertTransformOptionsFromBaseToReal: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 3) / 2,
        translateY: (translateY * 42) / 30,
      };
    },
    convertTransformOptionsFromRealToBase: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 2) / 3,
        translateY: (translateY * 30) / 42,
      };
    },
  },
  {
    name: 'ART_FRAMED_RECT_50X70',
    title: '50X70 cm',
    aspectRatio: '50:70',
    orientation: 'vertical',
    getFrameSettings: () => {
      return { width: 552.5, height: 773.5 };
    },
    convertTransformOptionsFromBaseToReal: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 5) / 2,
        translateY: (translateY * 7) / 3,
      };
    },
    convertTransformOptionsFromRealToBase: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 2) / 5,
        translateY: (translateY * 3) / 7,
      };
    },
  },
  {
    name: 'ART_FRAMED_RECT_70X100',
    title: '70X100 cm',
    aspectRatio: '70:100',
    orientation: 'vertical',
    getFrameSettings: () => {
      return { width: 773.5, height: 1105 };
    },
    convertTransformOptionsFromBaseToReal: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 7) / 2,
        translateY: (translateY * 10) / 3,
      };
    },
    convertTransformOptionsFromRealToBase: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 2) / 7,
        translateY: (translateY * 3) / 10,
      };
    },
  },
  {
    name: 'ART_FRAMED_RECT_30X20',
    title: '30X20 cm',
    aspectRatio: '30:20',
    orientation: 'horizontal',
    getFrameSettings: () => {
      return { width: 331.5, height: 221 };
    },
    convertTransformOptionsFromBaseToReal: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX,
        translateY,
      };
    },
    convertTransformOptionsFromRealToBase: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX,
        translateY,
      };
    },
  },
  {
    name: 'ART_FRAMED_RECT_42X30',
    title: '42X30 cm',
    aspectRatio: '42:30',
    orientation: 'horizontal',
    getFrameSettings: () => {
      return { width: 464.1, height: 331.5 };
    },
    convertTransformOptionsFromBaseToReal: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 42) / 30,
        translateY: (translateY * 3) / 2,
      };
    },
    convertTransformOptionsFromRealToBase: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 30) / 42,
        translateY: (translateY * 2) / 3,
      };
    },
  },
  {
    name: 'ART_FRAMED_RECT_70X50',
    title: '70X50 cm',
    aspectRatio: '70:50',
    orientation: 'horizontal',
    getFrameSettings: () => {
      return { width: 773.5, height: 552.5 };
    },
    convertTransformOptionsFromBaseToReal: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 7) / 3,
        translateY: (translateY * 5) / 2,
      };
    },
    convertTransformOptionsFromRealToBase: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 3) / 7,
        translateY: (translateY * 2) / 5,
      };
    },
  },
  {
    name: 'ART_FRAMED_RECT_100X70',
    title: '100X70 cm',
    aspectRatio: '100:70',
    orientation: 'horizontal',
    getFrameSettings: () => {
      return { width: 1105, height: 773.5 };
    },
    convertTransformOptionsFromBaseToReal: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 10) / 3,
        translateY: (translateY * 7) / 2,
      };
    },
    convertTransformOptionsFromRealToBase: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 3) / 10,
        translateY: (translateY * 2) / 7,
      };
    },
  },
  {
    name: 'ART_FRAMED_RECT_20X20',
    title: '20X20 cm',
    aspectRatio: '20:20',
    orientation: 'same',
    getFrameSettings: () => {
      return { width: 221, height: 221 };
    },
    convertTransformOptionsFromBaseToReal: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX,
        translateY,
      };
    },
    convertTransformOptionsFromRealToBase: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX,
        translateY,
      };
    },
  },
  {
    name: 'ART_FRAMED_RECT_30X30',
    title: '30X30 cm',
    aspectRatio: '30:30',
    orientation: 'same',
    getFrameSettings: () => {
      return { width: 331.5, height: 331.5 };
    },
    convertTransformOptionsFromBaseToReal: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 3) / 2,
        translateY: (translateY * 3) / 2,
      };
    },
    convertTransformOptionsFromRealToBase: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 2) / 3,
        translateY: (translateY * 2) / 3,
      };
    },
  },
  {
    name: 'ART_FRAMED_RECT_50X50',
    title: '50X50 cm',
    aspectRatio: '50:50',
    orientation: 'same',
    getFrameSettings: () => {
      return { width: 552.5, height: 552.5 };
    },
    convertTransformOptionsFromBaseToReal: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 5) / 2,
        translateY: (translateY * 5) / 2,
      };
    },
    convertTransformOptionsFromRealToBase: ({ scale, translateX, translateY }) => {
      return {
        scale,
        translateX: (translateX * 2) / 5,
        translateY: (translateY * 2) / 5,
      };
    },
  },
];

export { DefaultAspectRatio, SkuTypes, ArtSkuTypes };
